/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TourClass } from '@shared/models';
import { TourViewMode } from '@shared/models/tour-view-mode';
import { attachAbsenceSummary, groupAbsencesByDepartment } from '@tours/store/absences-by-department';
import { ToursState } from '@tours/store/tours.state';

const selectToursState = createFeatureSelector<ToursState>('tours');
export const getCurrentTourClass = createSelector(selectToursState, state => state.currentTourClass);
export const getTours = createSelector(selectToursState, getCurrentTourClass, (state, tourClass) => {
  if (tourClass !== TourClass.All) {
    return state.tours.filter(tour => tour.tourType === tourClass);
  }
  return state.tours.filter(tour => tour.tourType !== TourClass.Return);
});
export const getReturns = createSelector(selectToursState, state => state.tours.filter(
  tour => tour.tourType === TourClass.Return
));
export const getCurrentTour = createSelector(selectToursState, state => state.currentTour);
export const hasError = createSelector(selectToursState, state => state.hasError);
export const isSidebarExpanded = createSelector(selectToursState, state => state.isSidebarExpanded);
export const getCurrentDate = createSelector(selectToursState, state => state.currentDate);
export const isActionPending = createSelector(selectToursState, state => state.actionPending);
export const getTourAppointmentClasses = createSelector(selectToursState, state => state.tourAppointmentClasses);
export const getCurrentAbsences = createSelector(selectToursState, state => state.currentAbsences);
export const getAbsenceSummary = createSelector(selectToursState, state => state.absenceSummary);

/**
 * Fuer die Liste unter dem Kalender: die Abwesenheiten des Tages nach Abteilung
 * gebuendelt, jeweils mit dem Personal- und Fahrzeugstand der Abteilung. Abteilungen
 * ohne Abwesenheit tauchen nicht auf, Ziele ohne Abteilung bilden die letzte Gruppe.
 */
export const getCurrentAbsencesByDepartment = createSelector(
  getCurrentAbsences,
  getAbsenceSummary,
  (absences, summary) => attachAbsenceSummary(groupAbsencesByDepartment(absences), summary)
);
export const getMonthlyStatistics = createSelector(selectToursState, state => state.monthlyStatistics);
export const getCurrentTourView = createSelector(selectToursState, state => state.currentView);
export const getCurrentLocation = createSelector(selectToursState, state => state.currentLocation);
export const getAvailableLocation = createSelector(selectToursState, state => state.locations);

export const getTourViewModeStateFilter = createSelector(
  selectToursState,
  (state, props: {tourViewMode: TourViewMode}) => {
    return state.viewModeFilters.hasOwnProperty(props.tourViewMode)
      ? state.viewModeFilters[props.tourViewMode].stateFilterValues
      : [];
  }
);
